'use client';
import { useEffect, useRef, useSyncExternalStore } from 'react';

const subscribe = (onChange: () => void) => {
  window.addEventListener('online', onChange);
  window.addEventListener('offline', onChange);
  return () => {
    window.removeEventListener('online', onChange);
    window.removeEventListener('offline', onChange);
  };
};

/** Browser connectivity from `navigator.onLine`; always online during server rendering. */
export const useOnlineStatus = () =>
  useSyncExternalStore(
    subscribe,
    () => navigator.onLine,
    () => true,
  );

/** Runs `callback` when the browser comes back online after being offline. */
export const useOnReconnect = (callback: () => void) => {
  const online = useOnlineStatus();
  const wasOffline = useRef(false);
  const latest = useRef(callback);
  latest.current = callback;

  useEffect(() => {
    if (!online) {
      wasOffline.current = true;
      return;
    }
    if (wasOffline.current) {
      wasOffline.current = false;
      latest.current();
    }
  }, [online]);
};
